import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=3b7cc473&scoped=true&"
import script from "./ChatList.vue?vue&type=script&lang=ts&"
export * from "./ChatList.vue?vue&type=script&lang=ts&"
import style0 from "./ChatList.vue?vue&type=style&index=0&id=3b7cc473&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7cc473",
  null
  
)

export default component.exports